import type { StatusPipStatus } from '@diwata/ironvale'
import type { FeedEnvelope, ItemStatus } from '@/api/feeds'

/** Generic envelope → tile status. Tiles sharpen this with their own reds. */
export function envelopeStatus(feed: FeedEnvelope): StatusPipStatus {
  if (feed.status === 'unavailable') return 'unavailable'
  if (feed.status === 'degraded') return 'warn'
  return 'ok'
}

/** Worst item status wins: red > warn > ok. */
export function worstItemStatus(
  feed: FeedEnvelope,
  statuses: ItemStatus[],
): StatusPipStatus {
  if (feed.status === 'unavailable') return 'unavailable'
  if (statuses.includes('red')) return 'red'
  if (statuses.includes('warn') || feed.status === 'degraded') return 'warn'
  return 'ok'
}

export function relativeTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const then = new Date(iso).getTime()
  if (Number.isNaN(then)) return '—'
  const minutes = Math.round((Date.now() - then) / 60_000)
  if (minutes < 1) return 'now'
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.round(minutes / 60)
  if (hours < 48) return `${hours}h ago`
  return `${Math.round(hours / 24)}d ago`
}

/** The quiet body line for an unavailable feed — a state, not an alarm. */
export function UnavailableNote({ feed }: { feed: FeedEnvelope }) {
  return <p className="ap-tile-note">{feed.reason ?? 'not available'}</p>
}
